import React, { Component } from 'react'
import s from './TickerList.module.css'
import Image from "next/legacy/image"
import { urlFor } from '@lib/sanity'

export interface TListForm {
  icon: any
  className: string
}

export interface TickerListProps {
  title?: String
  list?: Array<TListForm>
  className?: String
}

const TickerList: React.FC<TickerListProps> = ((props) => {
  const {
    list,
    className
  } = props

  return (
    <div className={s.root + ' ' + className + ' ticker_list'}>
      <div className={s.ticker + ` ticker`}>
        {list && list.map((item, index) => {
          const image = urlFor(item.icon).width(200).url()
          return <div className={s.ticker__item + ` ticker__item`} key={index}>
            {image && <div
              className='block w-full h-full block overflow-hidden relative'>
              <Image loading={'lazy'} alt={'TickerList1 image' + index} className={'hidden md:inline-block'} src={image} width={150}
                     height={150} />
            </div>}
          </div>
        })}
        {list && list.map((item, index) => {
          const image = urlFor(item.icon).width(200).url()
          return <div className={s.ticker__item + ` ticker__item`} key={index}>
            {image && <div
              className='block w-full h-full block overflow-hidden relative'>
              <Image loading={'lazy'} alt={'TickerList2 image' + index} src={image} width={150} height={150} />
            </div>}
          </div>
        })}
        {list && list.map((item, index) => {
          const image = urlFor(item.icon).width(200).url()
          return <div className={s.ticker__item + ` ticker__item`} key={index}>
            {image && <div
              className='block w-full h-full block overflow-hidden relative'>
              <Image loading={'lazy'} alt={'TickerList3 image' + index} className={'hidden sm:inline-block'} src={image} width={150}
                     height={150} />
            </div>}
          </div>
        })}
      </div>
    </div>
  )
})

export default TickerList
